/* eslint-disable implicit-arrow-linebreak */
import {
  deleteToken as deleteTokenOnFirebase,
  getUserNotificationToken
} from './firebasePushNotification'

export const CDN_CUSTOM_EVENTS_NAMES = {
  deleteAllTokens: 'deleteAllCDNTokens',
  deleteFirebaseTokenFinished: 'removeCDNFirebaseTokenFinished'
}

export const dispatchCustomEvent = (target, eventName, eventDetails = {}) => {
  if (!target || !target.dispatchEvent) return false

  const customEvent = new CustomEvent(eventName, { detail: eventDetails })

  console.debug(`[CDN DEBUG] Dispatching event ==> "${eventName}"`)
  console.debug('[CDN DEBUG]', customEvent)

  target.dispatchEvent(customEvent)

  console.debug(`[CDN DEBUG] Dispatched event ==> "${eventName}"`)

  return true
}

export const dispatchDeleteAllTokensEvent = (target) =>
  dispatchCustomEvent(target, CDN_CUSTOM_EVENTS_NAMES.deleteAllTokens)

export const dispatchFirebaseRemoveTokenFinishedEvent = (target, data = {}) =>
  dispatchCustomEvent(
    target,
    CDN_CUSTOM_EVENTS_NAMES.deleteFirebaseTokenFinished,
    data
  )

export const listenCustomEvent = (target, eventName) =>
  new Promise((resolve, reject) => {
    if (!target.addEventListener) return reject()

    return target.addEventListener(eventName, (event) => {
      console.debug(`[CDN DEBUG] Received custom event ==> "${eventName}"`)
      console.debug('[CDN DEBUG]', event)

      resolve(event)
    })
  })

export const listenFirebaseRemoveTokenEvent = (target) =>
  listenCustomEvent(target, CDN_CUSTOM_EVENTS_NAMES.deleteFirebaseTokenFinished)

export const deleteTokenOnFirebaseWithEvent = (firebaseConfig = {}) =>
  new Promise((resolve) => {
    getUserNotificationToken(firebaseConfig)
      .then((token) => {
        deleteTokenOnFirebase(token, firebaseConfig)
          .then(async (response) => {
            console.log(
              `[CDN DEBUG] "deleteTokenOnFirebase" response ==> ${response}`
            )

            dispatchFirebaseRemoveTokenFinishedEvent(window, { token })

            resolve(token)
          })
          .catch(() => resolve(null))
      })
      .catch(() => resolve(null))
  })
